<template>
  <div v-if="orderDetail.order_item">
    <b-overlay
      :show="loading"
      rounded="sm"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
    >
      <p class="title font-weight-bold">{{ $t('lbl_return_the_results') }}</p>

      <result-form-item 
        v-for="(item, index) in orderDetail.order_item.OrderItemAttachments"
        :key="item.id"
        :form="item"
        :index="index"
        :isCompletedOrder="isCompletedOrder"
        :isPendingOrder="isPendingOrder"
        :hasDraftData="hasDraftData"
        @upload="$emit('reload')"
        @delete="item.url = ''"
      >
      </result-form-item>

      <div v-if="!isCompletedOrder" class="flex justify-center mt-2">
        <span
          v-b-tooltip.top
          :title="$t( isUploadAllFile ? '' :  'lbl_please_upload_all_result_files')"
        >
          <b-button
            :disabled="!isUploadAllFile"
            @click="handleSubmit"
            variant="primary"
          >{{ $t('lbl_return_the_results') }}</b-button>
        </span>
      </div>

    </b-overlay>

    <ModalResultFormProcessor
      @onSuccess="handleCreateResultFormSuccess"
      :orderDetail="orderDetail"
    />
  </div>
</template>
<script>
import store from "@/store";
import {
  ORDER_FORM_PROCESSOR_STATUS,
  ORDER_FORM_DRAFT
} from "../../../../utils/constant";
import ModalResultFormProcessor from "./ModalResultFormProcessor.vue";
import ResultFormItem from './ResultFormItem.vue';

export default {
  components: {
    ModalResultFormProcessor,
    ResultFormItem
  },
  name: "Result",
  props: {
    orderDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      hasDraftData: false
    };
  },
  computed: {
    isPendingOrder() {
      return this.orderDetail?.status === ORDER_FORM_PROCESSOR_STATUS.PENDING;
    },
    isUploadAllFile() {
      return this.orderDetail?.order_item?.OrderItemAttachments?.every(
        item => item?.url
      );
    },
    isCompletedOrder() {
      return this.orderDetail?.status === ORDER_FORM_PROCESSOR_STATUS.COMPLETE;
    }
  },
  watch: {
    orderDetail: {
      deep: true,
      handler() {
        this.handleGetDraft();
      }
    }
  },
  beforeMount() {
    this.handleGetDraft();
  },
  methods: {
    handleSubmit() {
      this.$emit("changeStatus", {
        id: this.orderDetail.id,
        status: ORDER_FORM_PROCESSOR_STATUS.COMPLETE,
        successTitle: this.$t("lbl_results_returned_successfully"),
        errorTitle: this.$t("lbl_failed_to_return_the_results")
      });
    },
    handleCreateResultFormSuccess(url) {
      const params = {
        order_item_attachment_id: this.orderDetail.order_item
          .OrderItemAttachments[0].ID,
        url
      };

      store
        .dispatch("orders/updateAttachmentResult", {
          params,
          callback: () => {}
        })
        .then(() => {
          this.loading = false;
          this.$emit("reload");
        });
    },
    async handleGetDraft() {
      if (!this.orderDetail?.order_item_id) return;
      const orderItemId = Number(this.orderDetail.order_item_id);

      try {
        const params = {
          order_item_id: orderItemId,
          order_form_type: ORDER_FORM_DRAFT.RESULT_PROCESSOR
        };

        const response = await this.$rf
          .getRequest("CommonRequest")
          .getDraftOrderForm(params);

        const responseData = response.data?.data;
        this.hasDraftData = !!responseData?.content;
      } catch (error) {
        console.log(error);
        this.hasDraftData = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-name {
  font-weight: 600;
}

.description {
  font-size: 12px;

  a {
    text-decoration: underline;
  }
}

.save-btn {
  width: 50%;

  transform: translate(50%, 100%);
}

.cs-link {
  :hover {
    text-decoration: underline;
  }
}

.cs-box-item {
  border: 1px solid #20409b;
  padding: 12px;
  border-radius: 4px;
}

.cs-dropdown ::v-deep {
  button {
    background-color: transparent !important;
    padding: 0 !important;
    border: none !important;

    &:hover {
      background-color: transparent !important;
      padding: 0 !important;
      border: none !important;
      box-shadow: none !important;
    }

    &::after {
      display: none !important;
    }
  }
}
</style>